export function addLastClass() {
    var $hasChildren = $('.menu--primary .menu__item--haschildren');
    if ($hasChildren.length) {
        $hasChildren.last().addClass('menu__item--haschildren-last');
    }
}

export function toggleSubNav() {
    $('.menu__item__trigger').click(function () {
        var $this = $(this),
            $sub = $this.next('.menu__mega');

        $this.toggleClass('menu__item__trigger--active');
        $sub.slideToggle();
    })
}